/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useState } from "react";

// reactstrap components
import { Container } from "reactstrap";

// PDF
import Pdf from "re-pdf-viewer";
import '../../assets/css/pdf.css'

// LazyLoad
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function CreditsText() {

  window.scrollTo(0, 0);

  let i = null;
  let paginas_array = [];

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);

  console.log(page + "/" + pages)

  for (i = 1; i < 45; i++) {
    paginas_array.push(i);
  }

  return (
    <>
      <div className="section section-dark section-dark-theme gradient-background-claro">
        <Container className="tim-container">
          <div>
            {i ?
              paginas_array.map((pag, index) => {
                return (
                  <div delay={0} key={index}>
                    <LazyLoadComponent visibleByDefault={false} effect="blur" >
                      <div>
                        <Pdf
                          file={require('../../assets/pdf/Credits-' + parseInt(pag) + '.pdf')}
                          scale={2}
                          setPages={(num) => setPages(num)}
                          setPage={(num) => setPage(num)}
                          loading={<div style={{ width: '100%', textAlign: 'center' }} > <h3>Loading... <i className="fa fa-spinner fa-spin" style={{ fontSize: '20px' }}></i> </h3></div>}
                        />
                      </div>
                    </LazyLoadComponent>
                  </div>
                )
              })
              :
              <fieldset></fieldset>
            }
          </div>
        </Container>
      </div>
    </>
  );
}

export default CreditsText;